export const ML_ACCEPTED_MIME_TYPES = ['image/jpeg', 'image/png'];
export const isFileTypeValid = (photo: File) => {
  const allowedTypes = ML_ACCEPTED_MIME_TYPES;
  return allowedTypes.includes(photo.type);
};
